module.exports = __webpack_public_path__ + "img/btn_del.2ef5c922.svg";